__turbopack_context__.v({
  "dark": "Tooltip-module__NajS2W__dark",
  "green": "Tooltip-module__NajS2W__green",
  "greenDark": "Tooltip-module__NajS2W__greenDark",
  "portalText": "Tooltip-module__NajS2W__portalText",
  "portalTextBottom": "Tooltip-module__NajS2W__portalTextBottom",
  "portalTextLeft": "Tooltip-module__NajS2W__portalTextLeft",
  "portalTextRight": "Tooltip-module__NajS2W__portalTextRight",
  "portalTextTop": "Tooltip-module__NajS2W__portalTextTop",
  "portalTrigger": "Tooltip-module__NajS2W__portalTrigger",
  "tooltip": "Tooltip-module__NajS2W__tooltip",
  "tooltipText": "Tooltip-module__NajS2W__tooltipText",
  "tooltipTextBottom": "Tooltip-module__NajS2W__tooltipTextBottom",
  "tooltipTextBottomLeft": "Tooltip-module__NajS2W__tooltipTextBottomLeft",
  "tooltipTextBottomRight": "Tooltip-module__NajS2W__tooltipTextBottomRight",
  "tooltipTextLeft": "Tooltip-module__NajS2W__tooltipTextLeft",
  "tooltipTextRight": "Tooltip-module__NajS2W__tooltipTextRight",
  "tooltipTextTop": "Tooltip-module__NajS2W__tooltipTextTop",
  "tooltipTextTopLeft": "Tooltip-module__NajS2W__tooltipTextTopLeft",
  "tooltipTextTopRight": "Tooltip-module__NajS2W__tooltipTextTopRight",
  "tooltipTrigger": "Tooltip-module__NajS2W__tooltipTrigger",
});
